module.exports = __webpack_public_path__ + "img/hr-fast-inserter-hand-closed.29b5860f.png";